export enum EmailSourceEnum {
  ArWithdrawalCancellation = 'ar_withdrawal_cancellation',
  ContactSales = 'contact_sales',
}

export enum EmailTemplateDisplayEnum {
  None = 'none',
  TableRow = 'table-row',
}
